import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const resendOtp = async (email) => {
    const response = await axios.post(routes.resendOtp, {
        email
    }, AXIOS_DEFAULT_CONFIG);
    return response;
}

export default resendOtp;
